import React, { useState } from "react";
import { Popup } from "../../../../library/popup";
import { ButtonGroup, ToggleButton, Carousel } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { sendErrorNotification } from "../../../../universal/notifications/notifications";
import CompanyDetails from "./company-details-container";
import PersonDetails from "./person-details-container";
import { ToastContainer } from "react-toastify";
import {
  changeClientsModal,
  requestAddSingleClient,
} from "../../../../../redux/actions/clients";
import { TransparentButton, SolidButton } from "../../../../library/button";
import { auth } from "../../../../../networking/firebase";
import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();

  const modalState = useSelector((state) => state.clients.showModals.addModal);

  const addLoading = useSelector((state) => state.clients.addClient.loading);

  const companyId = useSelector(
    (state) =>
      state &&
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );
  const [selection, setSelection] = useState("company");

  const [searchOrganizationNumber, setSearchOrganizationNumber] = useState("");
  const [companyObject, setCompanyObject] = useState({
    addedBy: auth.currentUser.uid,
    type: "company",
    logoUrl: null,
    general: {
      name: null,
      organizationNumber: searchOrganizationNumber,
      industry: null,
      employees: null,
      parentCompany: {
        id: null,
        infoUrl: null,
        name: null,
        organizationNumber: null,
      },
      established: null,
      shareCapital: null,
      roles: [],
      shareholders: [],
    },
    financials: {
      creditRating: {
        date: null,
        description: null,
        rating: null,
      },
    },
    address: {
      street: null,
      postalCode: null,
      city: null,
      coordinates: null,
      county: null,
      municipality: null,
      region: null,
    },
    contact: {
      phone: "",
      email: null,
      website: null,
    },
    social: {
      twitter: null,
      facebook: null,
    },
  });

  const [personObject, setPersonObject] = useState({
    addedBy: auth.currentUser.uid,
    type: "person",
    logoUrl: null,
    general: {
      firstName: null,
      lastName: null,
    },
    contact: {
      phone: "",
      email: null,
      website: null,
    },
    social: {
      twitter: null,
      facebook: null,
    },
    address: {
      street: null,
      postalCode: null,
      city: null,
    },
  });

  const handleClose = () => {
    setPersonObject({
      addedBy: auth.currentUser.uid,
      type: "person",
      logoUrl: null,
      general: {
        firstName: null,
        lastName: null,
      },
      contact: {
        phone: "",
        email: null,
        website: null,
      },
      social: {
        twitter: null,
        facebook: null,
      },
      address: {
        street: null,
        postalCode: null,
        city: null,
      },
    });
    setCompanyObject({
      addedBy: auth.currentUser.uid,
      type: "company",
      logoUrl: null,
      general: {
        name: null,
        organizationNumber: searchOrganizationNumber,
        industry: null,
        employees: null,
        parentCompany: {
          id: null,
          infoUrl: null,
          name: null,
          organizationNumber: null,
        },
        established: null,
        shareCapital: null,
        roles: [],
        shareholders: [],
      },
      financials: {
        creditRating: {
          date: null,
          description: null,
          rating: null,
        },
      },
      address: {
        street: null,
        postalCode: null,
        city: null,
        coordinates: null,
        county: null,
        municipality: null,
        region: null,
      },
      contact: {
        phone: "",
        email: null,
        website: null,
      },
      social: {
        twitter: null,
        facebook: null,
      },
    });
    dispatch(changeClientsModal({ addModal: false }));
  };

  const clickAddNewClient = () => {
    if (selection === "company") {
      if (
        Object.keys(companyObject).length > 0 &&
        companyObject.general &&
        companyObject.general.name &&
        companyObject.general.industry
      ) {
        dispatch(
          requestAddSingleClient({
            details: companyObject,
            companyId: companyId,
            type: "company",
          })
        );
      } else {
        sendErrorNotification("Du må legge inn bedriftsnavn og bransje.");
      }
    } else {
      if (
        Object.keys(personObject).length > 0 &&
        personObject.general &&
        personObject.general.firstName &&
        personObject.general.lastName
      ) {
        dispatch(
          requestAddSingleClient({
            details: personObject,
            companyId: companyId,
            type: "person",
          })
        );
      } else {
        sendErrorNotification("Du må legge inn fornavn og etternavn.");
      }
    }
  };

  return (
    <Popup
      onClose={handleClose}
      show={modalState}
      title="Legg til ny kunde"
      description="Du kan velge å legge til en bedriftskunde eller personkunde ved bruk av de to knappene rett nedenfor."
      buttons={[
        <TransparentButton
          title="Avbryt"
          type="button"
          data-dismiss="modal"
          onClick={() => handleClose()}
        />,
        <SolidButton
          color="blue"
          title={addLoading ? "Legger til.." : "Legg til"}
          icon={
            addLoading ? (
              <i className="fas fa-circle-notch fa-spin"></i>
            ) : (
              <i className="fas fa-plus"></i>
            )
          }
          onClick={() => clickAddNewClient()}
          type="button"
        />,
      ]}
    >
      <div className="new-client-content-container">
        <ButtonGroup className="selection-group" toggle>
          <ToggleButton
            className="single-selection"
            type="checkbox"
            checked={selection === "company" ? true : false}
            value="0"
            onChange={() => setSelection("company")}
          >
            Bedrift
          </ToggleButton>
          <ToggleButton
            className="single-selection"
            type="checkbox"
            checked={selection === "person" ? true : false}
            value="1"
            onChange={() => setSelection("person")}
          >
            Person
          </ToggleButton>
        </ButtonGroup>
        <Carousel
          activeIndex={selection === "person" ? 1 : 0}
          indicators={false}
          controls={false}
        >
          <Carousel.Item className="selection-item">
            <CompanyDetails
              searchOrganizationNumber={searchOrganizationNumber}
              setSearchOrganizationNumber={setSearchOrganizationNumber}
              companyObject={companyObject}
              setCompanyObject={setCompanyObject}
            />
          </Carousel.Item>
          <Carousel.Item className="selection-item">
            <PersonDetails
              personObject={personObject}
              setPersonObject={setPersonObject}
            />
          </Carousel.Item>
        </Carousel>
      </div>
      <ToastContainer />
    </Popup>
  );
};

export default Index;
